// "Continue with another tool": passes a result to the next tool in memory.
import type { OutputFile } from '../lib/files';

let pending: OutputFile[] | null = null;

export function setHandoff(files: OutputFile[]): void {
  pending = files;
}

export function takeHandoff(): OutputFile[] | null {
  const files = pending;
  pending = null;
  return files;
}
